import { anyPass, isEmpty, isNil, reject } from "ramda";

export const cleanParams = <T extends object>(params: T): T => {
  return reject(anyPass([isEmpty, isNil]))(params);
};
